export const SurepayrollProgramCodeConstants = ['sure', 'nrth', 'mnis', 'wf'];
export const RunpayrollProgramCodeConstants = [
  'myob',
  'gbop',
  'hunt',
  'fbop',
  'sbop',
  'uboc',
  'tap',
  'tap ',
  'mtbk',
  'acct',
];
export const PaychexProgramCodeConstants = ['pxgo'];
export const TruistProgramCodeConstants = ['tru', 'sunt', 'sun2'];

const isBelongToProgramCode = (codes: string[]) => (programCode: string) => {
  const dict = codes.reduce(
    (acc, prop) => ((acc[prop] = true), acc),
    <{ [key: string]: boolean }>{}
  );
  return dict[programCode?.toLowerCase()] ?? false;
};

export const isSureClient = isBelongToProgramCode(SurepayrollProgramCodeConstants);
export const isRpClient = isBelongToProgramCode(RunpayrollProgramCodeConstants);
export const isPxClient = isBelongToProgramCode(PaychexProgramCodeConstants);
export const isTrustClient = isBelongToProgramCode(TruistProgramCodeConstants);
export const isThemedClient = (programCode: string) =>
  isSureClient(programCode) ||
  isRpClient(programCode) ||
  isPxClient(programCode) ||
  isTrustClient(programCode);
